module.exports = __webpack_public_path__ + "static/media/SE_Logo_Proud_To_Support_V2_White.e7781216.png";